import React from 'react'
import styled, { keyframes } from 'styled-components'
import SentimentNeutralIcon from '@mui/icons-material/SentimentNeutral';

function NoData() {
  return (
    <Container>
        <SentimentNeutralIcon />
        <p>We apologize, but there is no data available!</p>
    </Container>
  )
}

export default NoData


const FadeEffect = keyframes`
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
`


const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    width: 90%;
    justify-content: center;
    padding: 10px;
    z-index: 10000;
    border-radius: 3px;
    margin-top: 30px;
    margin-left: 35px;
    color: white;

    opacity: 0;
    animation: ${FadeEffect} 0.3s ease-in-out forwards;
`